<template>
    <div>
        <o-table ref="tableList" :enable-delete="false"
                 :enable-new="false" :enable-view="false" default-sort-by="full_name"  :enable-edit="false" :title="$t('sandoz.cp_customers')"
                 :url="'/api/customers?include=extension,contracts,external_ids,external_ids.customer_login'"
                 :extra-row-button="[{icon: 'arrow-right'}]">
            <template slot="filter">
                <o-filter v-on:filter-updated="(filters) => $refs.tableList.setFilters(filters)" :filter-cacheable="true">
                    <o-filter-text :title="$t('sandoz.customer_external_id')" column="external_id"></o-filter-text>
                    <o-filter-text :title="$t('sandoz.name')" column="full_name" :prepend-percentage="true"></o-filter-text>
                    <o-filter-text :title="$t('sandoz.street')" column="street"></o-filter-text>
                    <o-filter-text :title="$t('sandoz.zip')" column="zip_code"></o-filter-text>
                    <o-filter-text :title="$t('sandoz.city')" column="city"></o-filter-text>
                    <o-filter-text :title="$t('sandoz.user_email')" column="user_email"></o-filter-text>
                    <o-filter-checkbox class="sales-reps" :items="salesPersons" :title="$t('sandoz.responsible_sales_person')" column="sales_person"></o-filter-checkbox>
                </o-filter>
            </template>
            <template slot="head">
                <o-table-header column="customer_external_id">{{ $t('sandoz.customer_external_id') }}</o-table-header>
                <o-table-header column="full_name">{{ $t('sandoz.address') }}</o-table-header>
                <o-table-header column="bank" :sortable="false">{{ $t('sandoz.bank') }}</o-table-header>
                <o-table-header column="contracts" :sortable="false">{{ $t('sandoz.contracts') }}</o-table-header>
                <o-table-header column="users" :sortable="false">{{ $t('sandoz.users') }}</o-table-header>
            </template>
            <template slot="body" slot-scope="props">
                <td>{{props.item.external_id}}</td>
                <td>
                    {{props.item.full_name}}<br>
                    <template v-if="props.item.street">{{props.item.street}}<br></template>

                    <template v-if="props.item.zip_code || props.item.city">{{props.item.zip_code}} {{props.item.city}}<br></template>
                </td>
                <td>
                    <template v-if="props.item.extension && props.item.extension.data">
                        <template v-if="props.item.extension.data.iban">{{props.item.extension.data.iban}}<br></template>
                        <template v-else>
                            <span class="badge-mandatory-missing">IBAN missing</span>
                            <br>
                        </template>

                        <template v-if="props.item.extension.data.bank_name">
                            {{props.item.extension.data.bank_name}}
                        </template>
                        <template v-else>
                            <span class="badge-mandatory-missing">Bank name missing</span>
                        </template>
                        /
                        <template v-if="props.item.extension.data.bank_address">
                            {{props.item.extension.data.bank_address}}
                        </template>
                        <template v-else>
                            <span class="badge-optional-missing">Bank address missing</span>
                        </template>
                        <br>

                        <template v-if="props.item.extension.data.bank_account">
                            {{props.item.extension.data.bank_account}}
                        </template>
                        <template v-else>
                            <span class="badge-mandatory-missing">Account holder missing</span>
                        </template>
                        <template v-if="props.item.extension.data.bank_account_address">
                            {{props.item.extension.data.bank_account_address}}
                        </template>
                        <template v-else>
                            <span class="badge-optional-missing">Account holder address missing</span>
                        </template>
                        <br>

                        <template v-if="props.item.extension.data.vat">
                            {{props.item.extension.data.vat}}
                        </template>
                        <template v-else>
                            <span class="badge-optional-missing">VAT no missing</span>
                        </template>
                    </template>

                    <template v-if="props.item.extension && props.item.extension.data && checkEduContract(props.item.contracts.data)">
                        <template v-if="props.item.extension.data.iban_edu"><br>{{props.item.extension.data.iban_edu}}<br></template>
                        <template v-else>
                            <span class="badge-mandatory-missing">Educational IBAN missing</span>
                            <br>
                        </template>

                        <template v-if="props.item.extension.data.bank_name_edu">
                            {{props.item.extension.data.bank_name_edu}}
                        </template>
                        <template v-else>
                            <span class="badge-mandatory-missing">Educational Bank name missing</span>
                        </template>
                        /
                        <template v-if="props.item.extension.data.bank_address_edu">
                            {{props.item.extension.data.bank_address_edu}}
                        </template>
                        <template v-else>
                            <span class="badge-optional-missing">Educational Bank address missing</span>
                        </template>
                        <br>

                        <template v-if="props.item.extension.data.bank_account_edu">
                            {{props.item.extension.data.bank_account_edu}}
                        </template>
                        <template v-else>
                            <span class="badge-mandatory-missing">Educational Account holder missing</span>
                        </template>
                        <template v-if="props.item.extension.data.bank_account_address_edu">
                            {{props.item.extension.data.bank_account_address_edu}}
                        </template>
                        <template v-else>
                            <span class="badge-optional-missing">Educational Account holder address missing</span>
                        </template>
                        <br>
                    </template>
                </td>
                <td>
                    <div v-for="contract in props.item.contracts.data" :key="contract.contract_no">
                        {{contract.contract_no}}
                    </div>
                </td>
                <td>
                    <div v-for="externalId in props.item.external_ids.data" :key="externalId.customer_login.data.email">
                        {{externalId.customer_login.data.email}}
                    </div>
                </td>
            </template>
            <template slot="body-controls" slot-scope="props">
                <td class="text-right">
                    <b-btn variant="primary" @click.prevent="$router.push({name: 'customers.detail', params: {id: props.item.id_contact}})">
                        <fa icon="arrow-right"/>
                    </b-btn>
                </td>
            </template>
        </o-table>

    </div>
</template>

<style scope>
.sales-reps ul {
    width: 250px;
}
.badge-optional-missing {
    color: #212529;
    background-color: #fdf5dd;
    border-radius: 0.125rem;
    display: inline-block;
    padding: 0.25em 0.4em;
    font-size: 75%;
    font-weight: 700;
    line-height: 1;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
}
.badge-mandatory-missing {
    color: #212529;
    background-color: #ffdcda;
    border-radius: 0.125rem;
    display: inline-block;
    padding: 0.25em 0.4em;
    font-size: 75%;
    font-weight: 700;
    line-height: 1;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
}
</style>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
    data: () => ({
        salesPersons: []
    }),
    computed: {
        ...mapGetters({
            user: 'auth/user'
        })
    },
    created () {

    },
    mounted() {
        this.getContractSalesPerson()
    },
    methods: {
        getContractSalesPerson () {
            var self = this
            axios.get('/api/verifications/contract_sales_persons').then((response) => {
                if (response.data.length) {
                    response.data.forEach(function (person) {
                        self.salesPersons.push({ value: person, text: person })
                    })
                }
            }).catch((error) => {
                console.error(error)
            })
        },
        checkEduContract(contracts) {
            var eduContract = false
            contracts.forEach((contract, index) => {
                if (contract.type.endsWith("_EDU")) {
                    eduContract = true
                }
            });
            return eduContract
        }
    }
}
</script>

